import type { CSSProperties } from "react";

export interface SystemStatus {
  showHeader?: boolean;
  showSidebar?: boolean;
  sideBarStyle?: CSSProperties;
}

export interface GlobalBridgeState {
  appId: number;
  debug: boolean;
  isInplaceCopilot: boolean;
  mode: string | null;
  organizationId: string | null;
  source: string | null;
  workspaceId: string | null;
}

export interface GlobalRouteState {
  pathname: string;
  search: string;
}

export interface GlobalState {
  route: GlobalRouteState;
  bridge: GlobalBridgeState;
  status: SystemStatus;
}

export const INITIAL_STATUS: SystemStatus = {
  showHeader: true,
  showSidebar: true,
  sideBarStyle: undefined,
};

export const initialState: GlobalState = {
  route: {
    pathname: "",
    search: "",
  },
  bridge: {
    appId: 0,
    debug: false,
    isInplaceCopilot: false,
    mode: null,
    organizationId: null,
    source: null,
    workspaceId: null,
  },
  status: INITIAL_STATUS,
};
